export enum Language {
  PL = "PL",
  EN = "EN"
}